import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_TITLE',
    defaultMessage: 'E-Mail-Adresse oder Handynummer vergessen?',
  },
  description1: {
    id: 'LOGIN_ACCOUNT_SEARCH_CRITERIA_DESCRIPTION',
    defaultMessage:
      'Macht nichts: Wir prüfen jetzt Ihre Identität – und dann können Sie eine neue E-mail-Adresse zum Einloggen festlegen',
  },
  description2: {
    id: 'LOGIN_ACCOUNT_SEARCH_CRITERIA_DESCRIPTION_2',
    defaultMessage:
      "Los geht's mit Angaben, die Sie in Ihrem XING Profil hinterlegt haben:",
  },
  firstnameLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_FIRSTNAME_LABEL',
    defaultMessage: 'Vorname',
  },
  lastnameLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_LASTNAME_LABEL',
    defaultMessage: 'Nachname',
  },
  birthdateLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_BIRTHDATE_LABEL',
    defaultMessage: 'Geburtsdatum',
  },
  cityLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_CITY_LABEL',
    defaultMessage: 'Stadt (optional)',
  },
  email1Label: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAIL_1_LABEL',
    defaultMessage: 'E-Mail-Adresse 1 (optional)',
  },
  email2Label: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAIL_2_LABEL',
    defaultMessage: 'E-Mail-Adresse 2 (optional)',
  },
  emailsExplanation: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAILS_EXPLANATION',
    defaultMessage:
      'Geben Sie zunächst infrage kommende E-Mail-Adressen bzw. Handynummern ein, mit denen Sie sich bei XING registriert haben könnten.',
  },
  buttonContinue: {
    id: 'LOGIN_RECOVERY_CONTINUE',
    defaultMessage: 'Weiter',
  },
  datePlaceholder: {
    id: 'LOGIN_RECOVERY_DATE_PLACEHOLDER',
    defaultMessage: 'jjjj-mm-tt',
  },
});
